import React from "react";
import Header from "./Header";
import SideBar from "./SideBar";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <div id="layout-wrapper">
      <Header />
      <SideBar />
      <div class="main-content">
        <div class="page-content">
          <div class="container-fluid">{children}</div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
